import { render, staticRenderFns } from "./SearchResultsTab.vue?vue&type=template&id=34bda4b3"
import script from "./SearchResultsTab.vue?vue&type=script&lang=js"
export * from "./SearchResultsTab.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsTab.vue?vue&type=style&index=0&id=34bda4b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports